<div class="container">
    <div class="row mt-5">
        <div class="col mt-5">
            <h1>Contacto</h1>
            <div style="width: 100%"><iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=es&amp;q=Caferatta%203025+(DR%20Autoservicio)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe></div>
            <p class="text-justify my-5">Si necesitás que te asesoremos o tenés alguna duda podés escribirnos a nuestro WhatsApp: 3415952021.<br> 
                También podés enviarnos un mail a drautoserviciomayorista@gmail.com</p>
        </div>
    </div>
</div>